import {
  DOMAIN,
  PERMISSION,
  useCanManageJobPostsBool,
  useCanViewCareerPreferencesBool,
  useHasCapabilityBool
} from "@/hooks/useCapabilities";
import { canAccessCareerOverview } from "../_components/careerOverviewUtils";

export function useCanAccessCareerOverview(): boolean {
  const canViewCompensationProfiles = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewCompensationProfiles
  });
  const canViewCareerPreferences = useCanViewCareerPreferencesBool();
  const canManageJobPosts = useCanManageJobPostsBool();

  return canAccessCareerOverview({
    canViewCareerPreferences,
    canViewCompensationProfiles,
    canManageJobPosts
  });
}
